import { render, staticRenderFns } from "./RoomDiceChip.vue?vue&type=template&id=3d1325c4&lang=pug&"
import script from "./RoomDiceChip.vue?vue&type=script&lang=ts&"
export * from "./RoomDiceChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RoomDiceChip.vue"
export default component.exports